import React from 'react';
import { Bar } from 'react-chartjs-2';

import { useRequiredChartPlugins } from '../plugins/usePlugins.ts';
import { ChartContainer } from '../styled.ts';
import type { ChartJSOrUndefined, ChartProps } from '../types.ts';

type ChartType = 'bar';

const BarChart = React.forwardRef<ChartJSOrUndefined<ChartType>, ChartProps<ChartType>>(function BarChart(props, ref) {
  const { 'data-testid': testId, ...chartProps } = props;
  useRequiredChartPlugins<ChartType>(chartProps.options);

  return (
    <ChartContainer data-testid={testId} style={{ height: chartProps.height ? `${chartProps.height}px` : undefined }}>
      <Bar ref={ref} {...chartProps} />
    </ChartContainer>
  );
});

export default BarChart;
